import { FAQs } from "./FAQS";


export const FAQsRoute = () =>
  (<FAQs />)